var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgZip = function SvgZip(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 35,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    strokeWidth: 1.31,
    d: "M29 8.17V31.5a2.33 2.33 0 0 1-2.33 2.33H3.33A2.33 2.33 0 0 1 1 31.5v-28a2.33 2.33 0 0 1 2.33-2.33H22m7 7-7-7m7 7h-6.32a.68.68 0 0 1-.68-.68V1.17",
    className: "zip_svg__pdf_svg__pdf-icon"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212123",
    d: "M13.57 17.04 10.23 22h3.53v1.05H8.67v-.72l3.35-4.94H8.96v-1.06h4.6v.72Zm2.19 6H14.6v-6.72h1.16zm2.53-5.68v1.81h1.3c.42 0 .62-.07.77-.2.2-.17.33-.41.33-.7a.89.89 0 0 0-.33-.7c-.15-.13-.35-.2-.78-.2h-1.3Zm1.41 2.85h-1.41v2.83h-1.15v-6.72h2.56c.63 0 1.04.15 1.36.39.47.35.78.91.78 1.56 0 .66-.3 1.2-.78 1.56-.32.24-.73.38-1.36.38",
    className: "zip_svg__pdf_svg__pdf-text"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212123",
    d: "M6.5 1v9a2 2 0 1 0 4 0V1M6.5 7h4m-4-2h4m-4-2h4"
  })));
};
export default SvgZip;